import { sFetchJson } from "../../../../../../../../../../common/util/sFetchJson";
import { vocabGenre } from "../../../../../../../../../../types/vocab";
import { Quest } from "../types";

export async function getVocabQuests(): Promise<Quest[]> {
    const vocabGenres = await sFetchJson<vocabGenre[]>(
        "api/VocabQuiz/GetAllGenres"
    );
    if ("error" in vocabGenres) {
        return [];
    }

    return vocabGenres
        .map<Quest>(g => ({
            questKey: g.genreName,
            title: g.genreName
                .split("_")
                .map(n => n[0].toUpperCase() + n.substring(1))
                .join(" "),
            transitionTarget: "/vocabulary-quiz/" + g.genreName,
            checkCleared: () => checkVocabCleared(g.genreId),
            reward: { type: "coin", value: 20 },
        }))
        .reverse();
}

function checkVocabCleared(vocabGenreId: number) {
    return (
        Number(
            localStorage.getItem(`vocab-quiz-percentage-${vocabGenreId}`)
        ) === 100
    );
}
